import {
  SaveButton,
  useNotify,
  useTranslate,
  useRefresh,
  SimpleForm,
  Toolbar,
  DeleteButton,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
  NumberInput,
  Edit,
  required,
  SelectInput,
} from 'react-admin';

import { Stack } from '@mui/material';

import { PermissionGuard } from 'src/routes/components/permission-guard';
import { typeRpc, typeService } from 'src/assets/data';
import { XButton } from '../../components/XButton';
import { Iconify } from 'src/components/iconify';
import AuditLogDialog from '../../components/AuditLog/AuditLogDialog';
import { useState } from 'react';
import { Resources } from '../resource';

const EditSystemRPC = ({ id, record }: { id: string | number; record?: any }) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();
  const [auditLogOpen, setAuditLogOpen] = useState(false);
  const [auditTitle, setAuditTitle] = useState('Audit Logs');
  const [selectedRecord, setSelectedRecord] = useState<any>(null);

  return (
    <Edit
      id={id}
      transform={(data) => data.value}
      mutationMode="pessimistic"
      mutationOptions={{
        onSuccess: () => {
          notify(t('module.systemRpc.updateSuccess'), { type: 'success' });
          refresh();
        },
        onError: (error: any) => {
          const errorCode = error?.body?.code || error?.code;
          switch (errorCode) {
            case 'INTERNAL_SERVER_ERROR':
              notify(error?.message, { type: 'error' });
              break;
            default:
              notify(t('module.systemRpc.unknownErrorUpdate'), { type: 'error' });
              break;
          }
        },
      }}
    >
      <SimpleForm
        disableInvalidFormNotification
        sx={{
          backgroundColor: 'transparent',
          boxShadow: 'none',
          borderRadius: 0,
          '& .MuiPaper-root': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderRadius: 0,
          },
          '& .RaSimpleFormIterator-root': {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            borderRadius: 0,
          },
        }}
        toolbar={
          <Toolbar
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              px: 0,
            }}
          >
            <PermissionGuard resource="rpc" action="update" fallback={<></>}>
              <SaveButton />
            </PermissionGuard>
            <PermissionGuard resource="audit-logs" action="read" fallback={<></>}>
              <XButton
                variant="text"
                size="medium"
                color="secondary"
                disabled={!record?.hasAuditLog}
                onClick={() => {
                  setSelectedRecord(record);
                  setAuditTitle(`${t('resource.auditLogs')} - ChainId: ${record.chainId} (#${record.id})`);
                  setAuditLogOpen(true);
                }}
                label={t('resource.auditLogs')}
              >
                <Iconify icon="ph:note" />
              </XButton>
            </PermissionGuard>
            <PermissionGuard resource="rpc" action="delete" fallback={<></>}>
              <DeleteButton
                mutationMode="pessimistic"
                mutationOptions={{
                  onSuccess: () => {
                    notify(t('module.systemRpc.deleteSuccess'), { type: 'success' });
                    refresh();
                  },
                  onError: (error: any) => {
                    const errorCode = error?.body?.code || error?.code;
                    switch (errorCode) {
                      default:
                        notify(t('module.systemRpc.unknownErrorDelete'), { type: 'error' });
                        break;
                    }
                  },
                }}
              />
            </PermissionGuard>
          </Toolbar>
        }
      >
        <ArrayInput source="value" label="">
          <SimpleFormIterator
            inline
            sx={{
              '.RaSimpleFormIterator-line': {
                mb: 2,
                gap: 2,
                pb: 2,
              },
              '.RaSimpleFormIterator-form': {
                '@media (min-width: 1200px)': {
                  width: '90%',
                },
              },
            }}
          >
            <Stack direction={'column'} sx={{ width: '100%' }}>
              <Stack direction={'row'} alignItems={'center'} spacing={2} mb={1}>
                <SelectInput
                  source="service"
                  validate={[required()]}
                  helperText={false}
                  choices={typeService}
                  sx={{
                    marginTop: 0,
                  }}
                />
                <TextInput
                  source="uri"
                  helperText={false}
                  fullWidth
                  validate={[required()]}
                  sx={{
                    flexGrow: 1,
                  }}
                />
                {/* <CustomTagInput source="tag" label={t('module.categories.tags')} /> */}
                <SelectInput
                  source="type"
                  helperText={false}
                  choices={typeRpc}
                  sx={{
                    marginTop: 0,
                  }}
                />
                <NumberInput
                  source="weight"
                  helperText={false}
                  validate={[required()]}
                  sx={{
                    flexGrow: 0,
                  }}
                />
              </Stack>
              {/* <Stack>
                <CustomTagInput source="tag" label={t('module.categories.tags')} />
              </Stack> */}
            </Stack>
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
      <AuditLogDialog
        open={auditLogOpen}
        onClose={() => setAuditLogOpen(false)}
        resource={Resources.systemRpc}
        recordId={selectedRecord?.id}
        title={auditTitle}
      />
    </Edit>
  );
};

export default EditSystemRPC;
